const getEnvConfig = () => ({
  apolloUri:
    'https://nq4obrrjc5corbzb7ncslvreae.appsync-api.eu-west-1.amazonaws.com/graphql',
  clientId: '7coe7h1ibnocgq57fke8s7hamb',
  userpoolId: 'eu-west-1_AFUR1ZW3A',
  region: 'eu-west-1',
})

export default getEnvConfig
